import Container from '@material-ui/core/Container';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Content0 from './Content0';
import Content4 from './Content4';


export default function Contents(props) {
 

    return(
        <React.Fragment>
            <Container maxWidth={false} >
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    style={{ height: '100vh' }}
                >
                    <Content0
                        {...props}
               
                
                    ></Content0>

                    <Content4
                        {...props}               
                    ></Content4>
                </Grid>
            </Container>
        </React.Fragment>
    )
}